import { createAction } from 'redux-actions'

export const setSticky = createAction('STICKY/SET_STICKY')
